import httpClient from "../../../../api/axios";

export const ginoQuery = async (
  message: string,
  conversationId?: string,
  forcedIntent?: string,
  chatId?: number,
) => {
  const body: any = { message };
  if (conversationId) body.conversationId = conversationId;
  // A CTA carries the intent it targets; passing it forces the backend to skip
  // re-classification (which could mis-route the chip's label text).
  if (forcedIntent) body.forcedIntent = forcedIntent;
  // The chat room id links this turn to its room so a resumed chat is recognised
  // as a continuation — the backend reads prior turns from the room for context.
  if (chatId) body.chatId = chatId;
  const res = await httpClient.post("/gino/v1/query", body);
  return res.data;
};

export const ginoClarify = async (conversationId: string, answers: Record<string, string>) => {
  const res = await httpClient.post("/gino/v1/clarify", { conversationId, answers });
  return res.data;
};

export const ginoGetJob = async (jobId: string) => {
  const res = await httpClient.get(`/gino/v1/jobs/${jobId}`);
  return res.data;
};

export const startTalentReport = async () => {
  const res = await httpClient.post("/talent-report/start");
  return res.data;
};

export const replyTalentReport = async (threadId: string, message: string) => {
  const res = await httpClient.post("/talent-report/reply", { thread_id: threadId, message });
  return res.data;
};

export const downloadTalentReportPdf = async (reportId: string) => {
  const res = await httpClient.post(`/talent-report/${reportId}/export-pdf`, {}, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `talent-report-${reportId}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
